// https://vuex.vuejs.org/en/actions.html

import resellersService from '@/services/Admin/resellerService'
import store from '@/store'

export default {
  async RefreshResellers (context) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Resellers')
    var apiResult = await resellersService.getAll()
    if (apiResult.success === false) {
      store.dispatch('RemoveLoadingMessage', loadingId)
      return apiResult
    }
    context.commit('refreshResellers', apiResult.value)
    // load the dependencies
    if (store.state.general.countries.length === 0) {
      await store.dispatch('RefreshCountries')
    }
    store.dispatch('RemoveLoadingMessage', loadingId)
    return apiResult
  },
  async RefreshReseller (context, uid) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Loading Reseller')
    var apiResult = await resellersService.get(uid)
    store.dispatch('RemoveLoadingMessage', loadingId)
    if (apiResult.success) {
      context.commit('updateReseller', apiResult.value)
    }
    return apiResult
  },
  async CreateReseller (context, reseller) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Creating Reseller')
    var apiResult = await resellersService.create(reseller)
    store.dispatch('RemoveLoadingMessage', loadingId)
    if (apiResult.success) {
      context.commit('updateReseller', apiResult.value)
    }
    return apiResult
  },
  async UpdateReseller (context, reseller) {
    var loadingId = await store.dispatch('AddLoadingMessage', 'Updating Reseller')
    var apiResult = await resellersService.update(reseller)
    store.dispatch('RemoveLoadingMessage', loadingId)
    if (apiResult.success) {
      context.commit('updateReseller', apiResult.value)
    }
    return apiResult
  },
}
